import { Pipe, PipeTransform } from '@angular/core';
import { WebServiceService } from '../services/web-service.service';
@Pipe({
  name: 'setGetSearch'
})
export class SetGetSearchPipe implements PipeTransform {
  constructor(public ser: WebServiceService) {}
  transform(items: any[], filter: string): any {
    if (!items || !filter) {
    return items;
  }
  this.ser.setSearchedData(items.filter(item =>JSON.stringify(item).toLowerCase().indexOf(filter.toLowerCase()) !== -1))
  return items.filter(item =>JSON.stringify(item).toLowerCase().indexOf(filter.toLowerCase()) !== -1);
}

}



// WEBPACK FOOTER //
// /codebuild/output/src2339540171/src/src/app/shared/pipes/set-get-search.pipe.ts